import { registerQuery, useQuery } from 'data-fetching-client';
import Raven from 'raven-js';
import { startOAuth } from '../integrations/Trello/TrelloApi';
const GET_TRELLO_REDIRECT_URL = registerQuery({
  fieldName: 'trelloRedirectUrl',
  fetcher: startOAuth
});
export const useTrelloRedirectUrl = ({
  skip = false,
  url
}) => {
  var _data$trelloRedirectU;
  const {
    data,
    loading,
    error
  } = useQuery(GET_TRELLO_REDIRECT_URL, {
    onError: err => {
      Raven.captureException(err, {
        extra: {
          message: 'Error on starting OAuth for Trello'
        }
      });
    },
    skip
  });
  return {
    redirectUrl: data ? (_data$trelloRedirectU = data.trelloRedirectUrl) === null || _data$trelloRedirectU === void 0 ? void 0 : _data$trelloRedirectU.redirectUrl : url,
    loading,
    error
  };
};